<app-public-header></app-public-header>

<div class="page auth-page">
  <div class="page-content">
    <div class="container">
      <div class="row main-row">
        <div class="col-12 col-md-8 col-lg-5 p-5 d-flex align-items-center justify-content-center left-col">
          <div class="col-content">
            <h1 class="h2">{{ 'auth.resetPassword.h1' | translate }}</h1>
            <p class="lead">{{ 'auth.resetPassword.lead' | translate }}</p>
            <div class="form-wrapper mt-3">
              <form [formGroup]="form" (ngSubmit)="onFormSubmit(model)">
                <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
                <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate">
                </mat-spinner-button>
              </form>
            </div> <!-- /.form-wrapper -->
            <div class="mt-3">
              <a routerLink="../../login">{{ 'auth.resetPassword.login' | translate }}</a>
            </div>
          </div> <!-- /.col-content -->
        </div> <!-- /.col -->
      </div> <!-- /.row -->
    </div> <!-- /.container -->
  </div> <!-- /.page-content -->
</div> <!-- /.page -->

<app-public-footer></app-public-footer>